module.exports = __webpack_public_path__ + "img/invite-friend.785e8d27.png";